/** Tuning knobs - extend upgrades here without touching the scene graph. */

export const MAX_CUBES = 80;
export const MOBILE_MAX_CUBES = 48;
export const CUBE_SIZE = 0.28;
export const CUBE_DESPAWN_Y = -18;

export const CAMERA = {
  play: { x: 0, y: 1.1, z: 9.5 },
  heap: { x: 0, y: -0.6, z: 7.2 },
  intro: { x: 0, y: 1.4, z: 11 },
};

export const GROUND_Y = -2.2;
export const CENTRAL_Y = 0.35;

/**
 * Ordered progression. Thresholds are cumulative click counts (strikes).
 * `apply` returns a partial state patch merged into the store.
 *
 * Drip rule: after CASCADE, idle drip uses the same `spawnCount` as strikes
 * (`dripUsesSpawnCount: true`). Before CASCADE, drip still yields 1 fragment.
 * Drip never increments clickCount / strike progress.
 */
export const UPGRADES = [
  {
    id: "density",
    threshold: 25,
    name: "DENSITY",
    label: "Matter Multiplier",
    blurb: "Each strike yields twice the mass.",
    apply: () => ({ multiplier: 2 }),
  },
  {
    id: "cascade",
    threshold: 55,
    name: "CASCADE",
    label: "Fragment Burst",
    blurb: "Two shards eject with every strike - and every drip.",
    apply: () => ({ spawnCount: 2, dripUsesSpawnCount: true }),
  },
  {
    id: "core",
    threshold: 100,
    name: "CORE",
    label: "Auto Drip",
    blurb: "The Heap feeds itself.",
    apply: () => ({ autoDrip: true }),
  },
  {
    id: "orbit",
    threshold: 160,
    name: "ORBIT",
    label: "Fragment Swarm",
    blurb: "Three shards circle out with every strike and drip.",
    apply: () => ({ spawnCount: 3 }),
  },
  {
    id: "pulse",
    threshold: 240,
    name: "PULSE",
    label: "Mass Pulse",
    blurb: "Each strike and drip yields thrice the mass.",
    apply: () => ({ multiplier: 3 }),
  },
  {
    id: "vein",
    threshold: 320,
    name: "VEIN",
    label: "Living Vein",
    blurb: "The drip quickens. Fragments settle denser into the pile.",
    apply: () => ({ autoDripMs: 1400, compactFragments: true }),
  },
];

/** Stage labels newest-first for HUD (must match UPGRADES ids). */
export const STAGE_ORDER = [
  "vein",
  "pulse",
  "orbit",
  "core",
  "cascade",
  "density",
];

export const SAVE_KEY = "heap-clicker-v2";

export const AUTO_DRIP_MS = 2200;

/** Cap serialized pile positions so localStorage stays bounded. */
export const PILE_SNAPSHOT_CAP = 24;

/** Retire beginner prompt after this many strikes (or first unlock). */
export const PROMPT_RETIRE_STRIKES = 8;

/** Crit streak: N strikes inside the window → harder pulse + brief mult bump. */
export const STREAK_WINDOW_MS = 1800;
export const STREAK_HITS = 5;
export const STREAK_MULT_BONUS = 1;

/**
 * One optional MASS spend after CORE climax - not a shop.
 * Temporary +spawnCount; editorial overlay, dismissible once.
 */
export const SURGE_COST = 80;
export const SURGE_DURATION_MS = 20000;
export const SURGE_SPAWN_BONUS = 1;
